import React from 'react'

import Table from '../../../../../components/molecules/Table'
import EditingCell from './Cells/EditingCell'
import NameCell from './Cells/NameCell'
import DetailsCell from './Cells/DetailsCell'
import RolesPermissionsModal from '../RolesPermissionsModal'

import { columnHelper } from './helpers'
import { useRolesPermissions } from '../../../../../providers/RolesPermissionsProvider'
import { useBreakpoint } from '../../../../../providers/BreakpointProvider'
import useStyles from './styles'
import NoPermissionContainer from '../../../../../components/molecules/NoPermissionContainer'

const ExistingRolesSection = () => {
  const {
    state: { allRoles, rolesLoaded },
    openModal,
    error
  } = useRolesPermissions()
  const { isExtraSmall, isSmall, isMedium } = useBreakpoint()

  const classes = useStyles()

  const rolesArray = React.useMemo(() => {
    return Object.values(allRoles ?? {}) ?? []
  }, [allRoles])

  const columns = React.useMemo(() => {
    const nameColumn = columnHelper.accessor('name', {
      header: 'Name',
      cell: ({ row }) => (
        <NameCell name={row.original.name} row={row.original} />
      )
    })

    const detailsColumn = columnHelper.accessor('details', {
      header: 'Details',
      cell: ({ row }) => <DetailsCell details={row.original.details} />
    })

    const permissionsNumColumn = columnHelper.accessor('permissions', {
      header: 'Number of Permissions',
      cell: ({ row }) => <div>{row.original.permissions?.length ?? 0}</div>
    })

    const editColumn = columnHelper.accessor('system', {
      header: 'View',
      cell: ({ row }) => (
        <EditingCell systemRole={row.original.system} data={row.original} />
      )
    })

    if (isExtraSmall || isSmall || isMedium) {
      return [nameColumn, editColumn]
    }

    return [nameColumn, detailsColumn, permissionsNumColumn, editColumn]
  }, [isExtraSmall, isSmall, isMedium])

  return (
    <NoPermissionContainer skipAgentPage error={error}>
      <div className={classes.table}>
        <Table
          data={rolesArray}
          columns={columns}
          loaded={rolesLoaded}
          message='There are no roles'
          hideCount
          disablePagination
        />
        {openModal && <RolesPermissionsModal />}
      </div>
    </NoPermissionContainer>
  )
}

export default ExistingRolesSection
